/**
 * 拉曼数据查询 api
 */

import instance from '@/utils/axios';

/**
 * 获取拉曼检测数据
 * @param {*} data
 * @param { string } data.beginTime 开始时间
 * @param { string }   data.endTime 结束时间
 * @param { string }  data.officeId 机构id
 * @param { string }     data.limit 分页个数
 * @param { string }    data.offset 分页页码
 */
export function ramanQuertListServer(data) {
  return instance.post('/ramanDataCollection/query', { ...data });
}

/**
 * 保存拉曼检测数据
 * @param {Object} data
 * @param { string } data.laboratoryTime 检测时间
 * @param { string } data.laboratoryItem  检测项
 * @param { string } data.laboratoryValue 检测值
 * @param { string } data.remarks 备注
 * @param { string } data.id  id
 */
export function saveRamanInfoServer(data) {
  return instance.post('/ramanDataCollection/save', { ...data });
}

/**
 * 删除拉曼数据
 * @param {Object} data
 * @param { string } data.id
 */
export function deleteRamanInfoServer(data) {
  return instance.post('/ramanDataCollection/remove', { ...data });
}

/**
 * 获取拉曼测试结果
 * @param {Object} data
 * @param { string } data.deviceSn
 * @param { number } data.beginTimeLong
 * @param { number } data.endTimeLong
 */
export function getRamanTestResult(data) {
  return instance.post('/devicedata/ramanTestResultPage', { ...data });
}

/**
 * 获取拉曼测试结果
 * @param {Object} data
 * @param { string } data.deviceSn
 * @param { string } data.testCode
 * @param { number } data.collectCount
 * @param { number } data.accumulateCount
 */
export function getRamanTestResultSpectrum(data) {
  return instance.post('/devicedata/ramanTestResultSpectrum', { ...data });
}
